import { BoundedContent } from '@vp/swan';
import { GridLayout } from '@99designs/marketing-ui';

enum Tenant {
    Vistaprint = 'VISTAPRINT',
    NinetyNineDesigns = '99DESIGNS',
}

type Props = {
    children: React.ReactNode;
    tenant?: Tenant;
};

export function GridWithTenantLayout({ tenant = Tenant.NinetyNineDesigns, children }: Props) {
    if (tenant === Tenant.Vistaprint) {
        return <BoundedContent>{children}</BoundedContent>;
    }
    return <GridLayout>{children}</GridLayout>;
}
